var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{staticClass:"main-404"},[_c('f7-navbar',{attrs:{"title":"Not found","back-link":"Back"}}),_vm._v(" "),_c('f7-block',{attrs:{"strong":""}},[_c('p',[_vm._v("Sorry")]),_vm._v(" "),_c('p',[_vm._v("Requested content not found.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }